import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let sceneEnterB: any = null,
    sceneLeaveB: any = null,
    sceneTextEnterB: any = null,
    sceneTextLeaveB: any = null;
export default function B() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra_daily_use.launch.detail');
    const [active, setActive] = useState(0);
    const video1Ref = useRef();
    const video2Ref = useRef();
    const [textEnter, setTextEnter] = useState(false);
    const SITE_JP = 'jp';

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const clientH = (window.innerHeight || 0) * 0.2;
            const startH = Math.min(clientH, 150);
            const resizeAni = () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                if (sceneTextEnterB) {
                    AniContainer.removeScene(sceneTextEnterB);
                    sceneTextEnterB = null;
                }
                if (sceneTextLeaveB) {
                    AniContainer.removeScene(sceneTextLeaveB);
                    sceneTextLeaveB = null;
                }
                sceneTextEnterB = AniContainer.create({
                    triggerElement: '.dpu-detail-B .sticky-box',
                    triggerHook: 1,
                    offset: startH,
                    // duration: 200,
                    onEnter: () => setTextEnter(true),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneEnterB) {
                    AniContainer.removeScene(sceneEnterB);
                    sceneEnterB = null;
                }
                if (sceneLeaveB) {
                    AniContainer.removeScene(sceneLeaveB);
                    sceneLeaveB = null;
                }
                if (sceneTextEnterB) {
                    AniContainer.removeScene(sceneTextEnterB);
                    sceneTextEnterB = null;
                }
                if (sceneTextLeaveB) {
                    AniContainer.removeScene(sceneTextLeaveB);
                    sceneTextLeaveB = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section className={`dpu-detail-B dpu-detail-section ${css['dpu-detail-B']}`}>
            <div className="sticky-box">
                <div className={`info-text ${textEnter ? 'enter' : ''}`}>
                    <p className="subtitle">Automatic Time-Of-Use Strategy</p>
                    <h2 className="title">{t('secB_title')}</h2>
                    <p className="desc">
                        {t.rich('secB_desc', {
                            w: (text: any) => <span className="white-text">{text}</span>,
                            n: (text: any) => <span className="no-wrap">{text}</span>,
                            sup: (text: any) => <sup className="sup">{text}</sup>,
                        })}
                    </p>
                </div>
                <ul className="videos">
                    <li className={`video ${active === 0 ? 'active' : ''}`}>
                        <video
                            ref={video2Ref}
                            src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1716172503449/v2.mp4'}
                            muted
                            loop
                            autoPlay
                            playsInline
                            preload="auto"
                            width="100%"
                            height="100%"
                            aria-label={t('secB_tab2')}
                            // onEnded={handlePlayEnd}
                        />
                    </li>
                </ul>
            </div>
        </section>
    );
}
